<template>

<div v-if="item">
  <BaseControlBar>
    <!-- <BaseControlBar :back-url="backUrl"> -->
    <div class="flex-grow-1">
      <h1>銷售訂單</h1>
    </div>
    <div class="button-wrapper">
      <template v-if="role === 'admin' || role === 'sale'">
        <BaseButton v-if="item.currentStatus.status === 'REFUND_PENDING'"
                    @click="$bvModal.show('modal-cancelled')"
                    variant="outline-secondary">
                    <div class="icon icon-refund"></div>
                    取消退款
        </BaseButton>

        <BaseButton v-if="item.currentStatus.status === 'REFUND_PENDING'"
                    @click="$bvModal.show('modal-finished')"
                    variant="outline-secondary">
                    <div class="icon icon-refund"></div>
          退款完成
        </BaseButton>

        <BaseButton v-if="item.currentStatus.status === 'REDEEMED' && role === 'admin'"
        @click="$bvModal.show('modal-refund')"
        variant="outline-secondary">
          <div class="icon icon-refund"></div>
          申請退款
        </BaseButton>

        <BaseButton v-if="item.deliveryStatus === 'DELIVERED'"
                    @click="$bvModal.show('modal-delivery-shipped')"
                    variant="outline-secondary">
                    <div class="icon icon-delivery"></div>
                    查看發貨詳情
        </BaseButton>
        <BaseButton v-else
                    @click="$bvModal.show('modal-delivery-select')"
                    variant="outline-secondary">
                    <div class="icon icon-delivery"></div>
                    送貨狀態
        </BaseButton>
      </template>
      <template v-if="role === 'merchant'">
        <BaseButton v-if="item.deliveryStatus === 'DELIVERED'"
                    @click="$bvModal.show('modal-delivery-shipped')"
                    variant="outline-secondary">
                    <div class="icon icon-delivery"></div>
                    查看發貨詳情
        </BaseButton>
        <BaseButton v-else
                    @click="$bvModal.show('modal-delivery-select')"
                    variant="outline-secondary">
                    <div class="icon icon-delivery"></div>
                    送貨狀態
        </BaseButton>
      </template>
      <BaseButton @click="goToReward" variant="outline-secondary">
        <div class="icon icon-search"></div>
        查看優惠券
      </BaseButton>
    </div>
    <BaseActionModal
          id="modal-refund"
          :title="refundTitle"
          okTitle="退款"
          :loading="loading"
          :isDisabled="isDisabled"
          @cancel-click="handleCancel"
          @hidden="handleCancel"
          okVariant="danger"
          v-stream:ok-click="{ subject: onNext$, data: 'PENDING' }"
        >
            <div v-if="step === 1">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  v-model="selected"
                  :options="selectoptions"
                  :aria-describedby="ariaDescribedby"
                  name="radio-inline"
                  class="m-3 d-flex"
                  v-if="1 === 0"
                >
                  <AGCInput v-model.number="quantity"
                    v-if="selected === 'partial'"
                    name="數量"
                    :rules="{'required': true, 'maxValue':item.quantity, 'minValue' : 1}"
                    placeholder="數量"
                    type="number"
                    min="1"
                    step="1"
                    autofocus
                    mode="eager"
                  >
                  </AGCInput>

                </b-form-radio-group>
              </b-form-group>

                  <ContentEditor
                    v-model.trim="refundRemarks"
                    name="退款原因"
                    class="mb-3"
                ></ContentEditor>

              <b-form-group>
                <label>商戶退款處埋</label>
                <b-form-radio-group
                  v-model="merchantBearAll"
                  :options="bearOptions"
                  name="radio"
                >
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div v-if="step >= 2">
              <b-container fluid>
                <b-row class="row-style">
                  <b-col cols="3">
                    <label>訂單編號</label>
                  </b-col>
                  <b-col cols="9" style="color:mediumseagreen">
                    {{ item.redemptionId }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="3">
                    <label>優惠名稱</label>
                  </b-col>
                  <b-col cols="9">
                    {{ item.name1 }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="3">
                    <label>數量</label>
                  </b-col>
                  <b-col cols="9">
                    {{ refundQuantity }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="3">
                    <label>退款總額</label>
                  </b-col>
                  <b-col cols="9">
                    {{ refundTotalWithCurrency }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="3">
                    <label>原因</label>
                  </b-col>
                  <b-col cols="9">
                    <!-- {{ item.remarks }} -->
                    <span v-html="refundRemarks"></span>
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="3">
                    <label>商戶退款處埋</label>
                  </b-col>
                  <b-col cols="9">
                    <span v-if="merchantBearAll">退回全單單價（包括5%平台費用）</span>
                    <span v-else>退回商戶可收取金額（全單單價95%）</span>
                  </b-col>
                </b-row>
              </b-container>
            </div>
    </BaseActionModal>
    <BaseActionModal
      id="modal-confirm-action"
      title="訂單處理中"
      :showCancelButton="false"
      @ok-click="closeModal"
      hideHeaderClose
      footerClass="d-flex justify-content-center"
      :loading="loading"
    >
    </BaseActionModal>
    <BaseActionModal
      id="modal-cancelled"
      title="確定取消退款？"
      @cancel-click="closeModal"
      @hidden="handleCancel"
      hideHeaderClose
      v-stream:ok-click="{ subject: onNext$, data: 'CANCELLED' }"
      footerClass="d-flex justify-content-center"
      :loading="loading"
    >
    </BaseActionModal>
    <BaseActionModal
      id="modal-finished"
      title="退款已完成？"
      @cancel-click="closeModal"
      @hidden = "handleCancel"

      v-stream:ok-click="{ subject: onNext$, data: 'FINISHED' }"
      :loading="loading"
    >
      <!-- :isDisabled="isDisabled" --in BaseActionModal component -->
      <!-- <ContentEditor
          v-model="refundRemarks"
          name="備註"
          class="mb-3"
      ></ContentEditor> -->
    </BaseActionModal>
    <DeliverySelectModal :redemptionItem="item"
                         @update="updateDeliveryStatus"
                         :deliveryStatus="deliveryStatus"
                         :role="role"
                         :loading="loading">
    </DeliverySelectModal>
    <DeliveryShippedtModal :id="id"
                           :redemptionItem="item"
                           :deliveryStatusDetail="deliveryStatusDetail">
    </DeliveryShippedtModal>
  </BaseControlBar>
  <div class="mobile-button-wrapper">
    <template v-if="role === 'admin' || role === 'sale'">
      <div class="item-wrapper" v-if="item.currentStatus.status === 'REFUND_PENDING'">
        <div class="item">
          <button @click="$bvModal.show('modal-cancelled')"
            variant="outline-secondary">
          <div class="icon icon-refund"></div>
          取消退款
          </button>
        </div>
      </div>
      <div class="item-wrapper" v-if="item.currentStatus.status === 'REFUND_PENDING'">
        <div class="item">
          <button @click="$bvModal.show('modal-finished')"
          variant="outline-secondary">
          <div class="icon icon-refund"></div>
            退款完成
          </button>
        </div>
      </div>
      <div class="item-wrapper" v-if="item.currentStatus.status === 'REDEEMED' && role === 'admin'">
        <div class="item">
        <button @click="$bvModal.show('modal-refund')"
        variant="outline-secondary">
          <div class="icon icon-refund"></div>
          申請退款
        </button>
        </div>
      </div>
      <div class="item-wrapper">
        <div class="item">
        <button v-if="item.deliveryStatus === 'DELIVERED'"
        @click="$bvModal.show('modal-delivery-shipped')"
        variant="outline-secondary">
          <div class="icon icon-delivery"></div>
          查看發貨詳情
        </button>
        <button v-else
        @click="$bvModal.show('modal-delivery-select')"
        variant="outline-secondary">
        <div class="icon icon-delivery"></div>
        送貨狀態
        </button>
        </div>
      </div>
    </template>
    <template v-if="role === 'merchant'">
      <div class="item-wrapper">
        <div class="item">
          <button v-if="item.deliveryStatus === 'DELIVERED'"
          @click="$bvModal.show('modal-delivery-shipped')"
          variant="outline-secondary">
            <div class="icon icon-delivery"></div>
            查看發貨詳情
          </button>
          <button v-else
          @click="$bvModal.show('modal-delivery-select')"
          variant="outline-secondary">
            <div class="icon icon-delivery"></div>
            送貨狀態
          </button>
        </div>
      </div>
    </template>
    <div class="item-wrapper">
      <div class="item">
        <button @click="goToReward" variant="outline-secondary">
          <div class="icon icon-search"></div>
          查看優惠券
        </button>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="coupon-form row">
      <div class="col-12 col-md-9">
        <div class="coupon-form__body">
            <StatusCard
              v-if="item.currentStatus.status"
              :status="item.currentStatus.status"
              :id="item.redemptionId"
              statusType="PaymentCoupon"
              :lastUpdateTime="item.currentStatus.createdAt"
              :refundRemark="refundRemark"
            >
              <template v-slot:header>
                <CouponStatusCard :redemptionId="item.ref"></CouponStatusCard>
              </template>
            </StatusCard>
            <div class="form-card">
              <b-container fluid>
                <div v-if="item.currentStatus.status !== 'REDEEMED'">
                  <h4>退款詳情</h4>
                  <b-row class="row-style">
                    <b-col >
                      <label>退款數量</label>
                    </b-col>
                    <b-col lg="9">
                      {{ item.refundQuantity }}
                    </b-col>
                  </b-row>
                  <b-row class="row-style">
                    <b-col >
                      <label>退款總額</label>
                    </b-col>
                    <b-col lg="9">
                      {{ item.refundTotal }}
                    </b-col>
                  </b-row>
                  <b-row class="row-style">
                    <b-col>
                      <label>退款原因</label>
                    </b-col>
                    <b-col>
                      <span v-html="item.refundRemarks"></span>
                    </b-col>
                  </b-row>
                </div>
                <h4>交易詳情</h4>
                <b-row class="row-style">
                  <b-col cols="4">
                    <label>訂單編號</label>
                  </b-col>
                  <b-col style="color:mediumseagreen">
                    {{ item.ref }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>交易時間</label>
                  </b-col>
                  <b-col>
                    {{ item.createdAtWithChineseFormat }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>付款方法</label>
                  </b-col>
                  <b-col>
                    {{ item.payMethod }}
                  </b-col>
                </b-row>

                <!--
                <b-row v-if="role === 'merchant'" class="row-style">
                  <b-col cols="4">
                    <label>訂單備註</label>
                  </b-col>
                  <b-col>
                    {{ item.remarks }}
                  </b-col>
                </b-row>
                -->

                <AGCEditGroupInput class="remark-style"
                      v-if="role === 'admin'"
                      v-model="item.remarks"
                     :fieldName="'remarks'"
                     name="訂單備註"
                     label="訂單備註"
                     type="text"
                     enableEdit
                     disabled
                     rules="required"
                     :inputType="'textarea'"
                  >
                </AGCEditGroupInput>

                <h4>優惠券資料</h4>
                <b-row class="row-style">
                  <b-col cols="4">
                    <label>商品編號</label>
                  </b-col>
                  <b-col style="color:orange">
                    {{ item.rewardId }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>優惠名稱</label>
                  </b-col>
                  <b-col>
                    <img v-if="item.photo" class="photo mr-2"
                    :src="item.photo | imagePath('couponCover')">
                    {{ item.name1 }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>數量</label>
                  </b-col>
                  <b-col>
                    {{ item.quantity }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>售價</label>
                  </b-col>
                  <b-col>
                    {{ item.pricePerUnit }}
                  </b-col>
                </b-row>

                <b-row class="row-style">
                  <b-col cols="4">
                    <label>總額</label>
                  </b-col>
                  <b-col>
                    {{ item.totalWithCurrency }}
                  </b-col>
                </b-row>

                <div v-if="stocks">
                  <h4>兌換情況</h4>
                  <div v-for="(stock, index) in stocks"
                    :key="`stock-${index}`">
                    <b-row class="row-style-no-border row-style">
                      <b-col cols="4">
                        <label>優惠碼{{ index + 1 }}</label>
                      </b-col>
                      <b-col>{{ stock.code }}</b-col>
                    </b-row>
                    <b-row class="row-style-no-border row-style">
                      <b-col cols="4">
                        <label>優惠碼狀態{{ index + 1 }}</label>
                      </b-col>
                      <b-col>
                        <StockStatusLabel :value="stock.state"></StockStatusLabel>
                      </b-col>
                    </b-row>
                    <b-row class="row-style-no-border row-style">
                      <b-col cols="4">
                        <label>優惠碼使用狀況{{ index + 1 }}</label>
                      </b-col>
                      <b-col>
                        <StockUsedLabel :value="stock.isUsed"></StockUsedLabel>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <div v-if="role === 'admin'">
                  <h4>買家資料</h4>
                  <b-row class="row-style">
                    <b-col cols="4">
                      <label>會員編號</label>
                    </b-col>
                    <b-col style="color:DodgerBlue">
                      {{ item.userId }}
                    </b-col>
                  </b-row>

                  <b-row class="row-style">
                    <b-col cols="4">
                      <label>會員名稱</label>
                    </b-col>
                    <b-col>
                      {{ item.username }}
                    </b-col>
                  </b-row>

                  <b-row class="row-style">
                    <b-col cols="4">
                      <label>聯絡電郵</label>
                    </b-col>
                    <b-col>
                      {{ item.email }}
                    </b-col>
                  </b-row>

                  <b-row class="row-style">
                    <b-col cols="4">
                      <label>聯絡電話</label>
                    </b-col>
                    <b-col>
                      {{ item.cell_phone }}
                    </b-col>
                  </b-row>

                  <b-row class="row-style">
                  </b-row>
                </div>
              </b-container>
            </div>

            <div class="form-card">
              <b-container fluid>
              <CustomQuestionTable :QnA="item.answers"></CustomQuestionTable>
              </b-container>
            </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script src="/js/DateFormat.js"></script>
<script>
import { mapState, mapGetters } from 'vuex';
// import { of, Subject } from 'rxjs';
import {
  pluck, map, startWith, switchMap, tap, filter
} from 'rxjs/operators';
import {
  VBScrollspy, BRow, BCol, BButton, BContainer, BFormRadioGroup, BFormGroup,
  BFormInput, BFormInvalidFeedback,
} from 'bootstrap-vue';
import cloneDeep from 'lodash.clonedeep';
import http from '../../helpers/http';
import StockStatusLabel from '../../components/coupon/StockStatusLabel.vue';
import StockUsedLabel from '../../components/coupon/StockUsedLabel.vue';
import StatusCard from '../../components/StatusCard.vue';
import AGCEditGroupInput from '../../components/form/AGCEditGroupInput.vue';
import CouponStatusCard from '../../components/coupon/CouponStatusCard.vue';
import BaseControlBar from '../../components/BaseControlBar.vue';
import BaseButton from '../../components/BaseButton.vue';
import BaseActionModal from '../../components/BaseActionModal.vue';
import imagePath from '../../filters/image-path';
import ContentEditor from '@/components/editor/ContentEditor.vue';
import AGCInput from '../../components/form/AGCInput.vue';
import CustomQuestionTable from '../../components/coupon/CustomQuestionTable.vue';
import DeliverySelectModal from '@/components/delivery-status/DeliverySelectModal.vue';
import DeliveryShippedtModal from '@/components/delivery-status/DeliveryShippedModal.vue';

export default {
  // mixins: [formMixin],
  components: {
    StatusCard,
    StockStatusLabel,
    StockUsedLabel,
    BCol,
    BRow,
    BButton,
    BContainer,
    BFormRadioGroup,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    AGCEditGroupInput,
    BaseControlBar,
    BaseButton,
    CouponStatusCard,
    ContentEditor,
    AGCInput,
    BaseActionModal,
    CustomQuestionTable,
    DeliverySelectModal,
    DeliveryShippedtModal,
  },
  data: () => ({
    active: true,
    loading: false,
    title: '',
    refundTitle:'確定申請退款？',
    refundSecondTitle:'',
    couponStateBeforeUpdate: null,
    refundStatus: '',
    refundRemarks: '',
    confirmRefundRemarks: '',
    quantity: '',
    selected: 'all',
    selectoptions: [
          { text: '全部退款', value: 'all' },
          { text: '部分', value: 'partial' },
        ],
    step: 1,
    apiKey: 'no-api-key',
    deliveryStatus: null,
    merchantBearAll: 0,
    bearOptions: [
      { text: '退回商戶可收取金額（全單單價95%）', value: 0 },
      { text: '退回全單單價（包括5%平台費用）', value: 1 },
    ],
  }),
  watch: {
    selected: function() {
        this.quantity = '';
      },
      step: function() {
        if (this.step === 1 ) {
          this.refundTitle = '確定申請退款？';
        }
        if (this.step >= 2 ) {
          this.refundTitle = '確定退款內容？';
        }
      }
    },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['role']),
    id() {
      return this.$route.params.id;
    },

    rewardId() {
      return this.item.rewardId;
    },

    backUrl() {
      return this.role === 'merchant' ? '/salesorder' : `/${this.role}/salesorder`;
    },

    checkQuantity() {
        return this.quantity <= this.item.quantity ? true : false
    },

    refundQuantity() {
      return this.quantity ? this.quantity : this.item.quantity;
    },
    refundTotal() {
      return (this.item.totalPrice / this.item.quantity * this.refundQuantity);
    },

    refundTotalWithCurrency() {
      return (this.refundTotal)
      .toLocaleString('en-US', {
        style: 'currency',
        currency: 'HKD',
      });
    },

    isDisabled() {
      if (this.selected === 'all') {
        return !this.refundRemarks;
      }
      return !this.refundRemarks || !this.quantity || this.quantity > this.item.quantity
    },

    fields() {
      return [
        { key: 'code', label: '優惠碼' },
        { key: 'state', label: '狀態' },
        { key: 'isUsed', label: '使用狀況' },
      ];
    },

    // init: {
    //   quickbars_insert_toolbar: false,
    //   height: '250',
    // },

    refundRemark() {
      if (this.item.currentStatus.status === 'REDEEMED') {
        return null;
      }
      return this.item.merchantBearAll
        ? '退回全單單價（包括5%平台費用）'
        : '退回商戶可收取金額（全單單價95%）';
    },

  },
  filters: {
    imagePath,
  },
  directives: {
    'b-scrollspy': VBScrollspy,
  },
  domStreams: ['onNext$'],
  subscriptions() {
    const getData$ = (id) => http({
      method: 'GET',
      url: `/agc-${this.role}-api/salesorder/details/${id}`,
    });

    const getStocksData$ = (rewardId) => http({
      method: 'GET',
      url: `/agc-${this.role}-api/salesorder/stocks/${rewardId}?redemptionId=${this.id}`,
    });

    const getDeliveryStatusDetail$ = (id) => http(
      {
        method: 'GET',
        url: `/agc-${this.role}-api/salesorder/getDeliveryStatusDetail/?redemptionId=${this.id}`,
      },
      {
        next: (res) => {
          if (res.length <= 0) {
            this.deliveryStatus === null;
          } else {
            this.deliveryStatus = res.status;
          }
        },
        complete: () => {
          this.loading = false;
        },
      }
    );

    return {
      item: this.$watchAsObservable('id').pipe(
        pluck('newValue'),
        startWith(this.id),
        switchMap(getData$),
      ),
      stocks: this.$watchAsObservable('item.rewardId').pipe(
        pluck('newValue'),
        switchMap(getStocksData$),
        pluck('result'),
      ),
      deliveryStatusDetail: this.$watchAsObservable('item.deliveryStatus').pipe(
        pluck('newValue'),
        tap(() => {
          this.loading = true;
        }),
        startWith(this.id),
        switchMap(getDeliveryStatusDetail$),
      ),

      next: this.onNext$
        .pipe(
          pluck('data'),
          tap((action) => {
            this.setRefundStatus(action);
            if (this.step < 3) {
              this.step += 1;
            }
          }),
          filter(() => this.step === 3),
          tap(() => {
              this.loading = true;
          }),
           switchMap(() => http({
            method: 'POST',
            url: `/agc-${this.role}-api/salesorder/addRefund`,
            data: {
              refundAction: this.refundStatus,
              remarks: this.refundRemarks,
              redemptionId: this.item.redemptionId,
              rewardId: this.item.rewardId,
              quantity: this.refundQuantity,
              total: this.refundTotal,
              merchantBearAll: this.merchantBearAll,
            },
          }, {
            error: ({ data: { msg } }) => {
              this.$bvToast.toast(getErrorMsg(msg, { DUPLICATED: `${this.label}已重覆，請重新輸入` }), {
                ...toastSettings,
                title: '錯誤',
                toaster: 'b-toaster-top-center',
              });
            },
            next: () => {
              // this.$emit('is-save');
              // this.isEditing = false;
              // this.cachedInputVal = this.inputVal;
              const action = this.refundStatus;
              this.$bvModal.hide('modal-refund');
              this.$bvModal.hide(`modal-${action.toLowerCase()}`);
              if (action === 'PENDING') {
                this.$bvModal.show('modal-confirm-action');
              }
            },
            complete: () => {
              this.loading = false;
              if (this.refundStatus === 'PENDING') {
                this.item.currentStatus.status = 'REFUND_PENDING';
                this.item.refundRemarks = this.refundRemarks;
                this.item.refundQuantity = this.refundQuantity;
                this.item.refundTotal = this.refundTotal;
              }
              if (this.refundStatus === 'CANCELLED') {
                this.item.currentStatus.status = 'REDEEMED';
              }
              if (this.refundStatus === 'FINISHED') {
                this.item.currentStatus.status = 'REFUND_FINISHED';
              }

              // this.item.currentStatus.status = this.refundStatus;
              this.refundRemarks = '';
              this.step = 1;

              // this.item.currentStatus.quantity = this.refundQuantity;
              // this.item.currentStatus.total = this.refundTotal;

              this.item.merchantBearAll = this.merchantBearAll;
              this.merchantBearAll = 0;
            },
          })),

        ),

    };

  },
  methods: {
    onCancel() {
      this.toggleReadOnly();
      this.$refs.form.reset();
      this.item = cloneDeep({
        ...this.couponStateBeforeUpdate,
        currentStatus: { ...this.item.currentStatus },
      });
    },
    goToReward() {
      const role = this.role === 'merchant' ? '' : `/${this.role}`;
      const paymentType = this.item.paymentType === 'UFUN' ? 'coupons' : 'paidCoupons';
      const goToUrl = `${role}/${paymentType}/${this.item.rewardId}`
      this.$router.push({
        path: goToUrl,
      });
    },

    setRefundStatus(action) {

      if (action === "CANCELLED") {
        this.refundStatus = 'CANCELLED';
        this.step = 3;
      }
      if (action === "FINISHED") {
        this.refundStatus = 'FINISHED';
        this.step = 3;
      }
      if (action === "PENDING") {
        this.refundStatus = 'PENDING';
      }

    },

    handleCancel() {
      this.quantity = '';
      this.selected = 'all';
      this.refundRemarks = '',
      this.$bvModal.hide('modal-refund');

      this.step = 1;
    },

    closeModal() {
      this.$bvModal.hide('modal-confirm-action');
      this.$bvModal.hide('modal-cancelled');
      this.$bvModal.hide('modal-finished');
      this.refundRemarks = '';

    },
    updateDeliveryStatus(status) {
      this.item.deliveryStatus = status;
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables';
@import '@/assets/scss/transition/fade';
@import '@/assets/scss/mixin/modal/modal-history-status';
@import '../../assets/scss/variables';
@import '../../assets/scss/coupon-form';

body {
  position: relative;
}

.row-style{
  border-bottom: 1px solid #EBEEF0 !important;
  margin-left: 0;
  margin-right: 0;
  box-sizing: border-box;
  padding: 10px 15px 6px 0 !important;
  .col{
    padding: 0px 15px 6px 0}
}

.row-style-no-border{
  border-bottom: none !important;
}

.form-card {
  display: flex;
  flex-direction: column;
  .remark-style{
    border-bottom: 1px solid #EBEEF0 !important;
    margin-left: 0;
    margin-right: 0;
    box-sizing: border-box;
    padding: 10px 15px 6px 0 !important;
  }

  .photo{
    width: 50px;
    height: 50px;
  }

}
  ::v-deep{.form-control{
    background:#F9F9FA;
    font-size: 15px;
    padding: 0.375rem 0.75rem 0.375rem 0.5rem;
    color: #636d77;
    display: inline-block;
    width: 350px;
    position: relative;
    width: 100%;
  }
   .form-control:disabled{
    background:none;
    border:none;
    padding: 0.375rem 0.75rem 0.375rem 0.5rem;
  }

  .border-bottom{
    border-bottom:none !important;
  }

  .input-left{
    padding: 6px 0px 0px 15px !important;
  }
}

.coupon-stock-card {
  @include container;

  .title {
    @include title;
  }
}

.row-style div:first-child {
  padding-left: 0px;
}

@media screen and (max-width: 650px) {
  .coupon-form{
    width: 100%;
  }

  .coupon-form .form-card{
    padding: 0px 0px;
  }

  .mobile{
    width: 150px;
  }

}
.button-wrapper {
  display: flex;
  @include respond(tab-landscape) {
    display: none;
  }
}
.mobile-button-wrapper {
    display: none;
    position: relative;
    top: -8px;
  @include respond(tab-landscape) {
    background: #fff;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .item-wrapper {
      width: 100%;
      color: #000;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      .item{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #ccc;
        margin: 5px 0px;
        button {
          flex-direction: row;
          background: none;
          border: none;
          color: gray;
          align-items: center;
          display: flex;
          padding: 5px 0px;
          font-size: 14px;
        }
      }
    }
  }
}
.icon {
    margin-right: 5px;
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
  }

  .icon-delivery {
    @include respond(tab-landscape) {
      width: 20px;
    }
    width: 20px;
    height: 20px;
    background-image: url(../../assets/img/icon/delivery.svg);
  }
  .icon-refund {
    width: 24px;
    height: 24px;
    background-image: url(../../assets/img/icon/cashout.svg);
  }

  .icon-search {
    background-image: url(../../assets/img/icon/search-coupon.svg);
  }
</style>
